import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='w-full border-t border-gray-200 bg-cream  ' style={{fontFamily: "Poppins"}}>
    <div className='w-full pt-6 pb-4 lg:px-10 px-2 bg-cream text-navy text-xs lg:text-sm flex justify-center flex-col items-center'>
      <div className='flex justify-around lg:justify-evenly items-start lg:w-1/2  w-full border-gray-200   border-b '>
            {/* <div className='flex flex-col'>
                <div className='text-gray-400 mb-4'>
                </div>
                <Link to='/howItWorks/2' className='mb-2'>Flow for Clients and Personal Injury Attorneys</Link>
                <Link to='/howItWorks/3' className='mb-2'>Flow for Assistants and Personal Injury Attorneys</Link>

                <Link to='/pricing' className='mb-2'>Pricing</Link>

            </div> */}
            <div className='flex w-full lg:justify-end justify-center lg:pr-4  items-center'>
              
                {/* <div className='text-gray-400'>Company & Legal</div> */}
                {/* <Link to='/investors' className='mb-2'>Investors </Link> */}
                {/* <Link to='/intellectual-property' className='mb-2'>Intellectual Property</Link> */}
                <Link to='/privacy-policy' className='mb-2 text-tan underline hover:text-tanDark'>Privacy Policy</Link>

            </div>
            <div className='flex lg:w-1/2 w-full justify-center border  border-gray-200 border-0 lg:border-1 lg:border-r-1 lg:border-l-1 border-t-0 border-b-0  items-center '>
                <Link to='/user-agreement' className='mb-2 text-tan underline hover:text-tanDark'>User Agreement</Link>

            </div>
            <div className='flex  w-full lg:justify-start lg:pl-4 justify-center  items-center'>
                {/* <div to='' className='text-gray-400 mb-4'>About Us</div> */}
                <Link to='/contact-us' className='mb-2 text-tan underline hover:text-tanDark'>Contact Us </Link>

                {/* <Link to='/our-story' className='mb-2'>Our Story </Link> */}

            </div>
            {/* <div className='flex flex-col'>
                <div className='text-gray-400 mb-4'>Support & Resources
                </div>
                <Link to='/survivor-resources' className='mb-2'>Survivor Resources</Link>
            </div> */}
            <div>
          {/* <div    
                className='text-gray-200 cursor-pointer'>
                  <div className='mb-2 text-gray-400'>Registered Office  </div>
                 5473 Blair RD STE 100 # 619812  <br/>Dallas, TX 75231 <br/>
                 <br/>
                 
                <a href='mailto:info@quickcasereview.com'
                
                className='  mg-10  cursor-pointer'>
                info@quickcasereview.com
                </a> <br/>
              </div> */}
        </div>
           
      </div>
     
     

      <div className='w-[98%] text-[11px]  border-1 border-t border-b-0 border-r-0 border-l-0  border-gray-200'>

         <div className='w-full  text-gray-400 border-1 border-t border-b-0 border-r-0 border-l-0 pt-4 border-gray-200'>
      Warning : The various computing functionalities, computing communications, computing interfaces, etc., of this Platform are protected with multiple U.S. patents and patent applications.  The founder, who filed her first patent application in 2019 and is domiciled in the Eastern District of Texas, is a prolific inventor and patent filer who holds multiple patents and patent applications in several technologies.  Intentional infringement of such patents may result in treble damages. 
      </div>
      <div className='mt-2 text-[10px] w-full flex justify-center '> © 2025 Quick Case Review. All rights reserved. </div>

      </div>
    </div>
   
    </div>
    
  )
}

export default Footer;
